<template>
	<div class="page-login">
		<div class="container">
			<div class="login">
				<h3>Reset Password</h3>
				<h5 class="text-center mt-4" v-if="isVerifyingCode">Verifying Password Reset Code..</h5>
				<div class="link-expired-box callout callout--danger" v-if="!isVerifyingCode && !isCodeValid">
					<div class="callout__title">Link Expired</div>
					<div class="callout__content">Your reset password link is expired, please try again <router-link to="/login?action=forgot_password">here</router-link></div>
				</div>
				<!-- Login Box -->
				<div class="login-box" v-if="isCodeValid">
					<div class="login-error callout callout--danger" v-if="error">
						<div class="callout__content">{{ error }}</div>
					</div>
					<div class="login-error callout callout--success" v-if="success">
						<div class="callout__title">Password successfully changed</div>
						<div class="callout__content">
							You can login with your new password <router-link to="/login">here</router-link>
						</div>
					</div>
					<form @submit.prevent="setPassword(email, password, code)">
						<div class="form-group">
							<label><b>New Password</b></label>
							<input type="password" class="input form-control" placeholder="Your new password" :class="{ 'error': !isNewPasswordValid }" v-model="password">
							<div class="field-error" v-if="!isNewPasswordValid">Password is minimal 6 character</div>
						</div>
						<div class="form-group">
							<label><b>Confirm New Password</b></label>
							<input type="password" class="input form-control" placeholder="Re-enter your new password" :class="{ 'error': !isNewPasswordMatch }" v-model="passwordConfirmation">
							<div class="field-error" v-if="!isNewPasswordMatch">New Password not match</div>
						</div>
						<button type="submit" class="btn btn-submit btn-primary btn-block" :class="[{ 'is-loading': isSettingNewPassword }]" :disabled="!isCanChangePassword">Set New Password</button>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import userApi from '../api/user';

export default {
	name: 'resetPassword',
	data() {
		return {
			success: false,
			error: false,
			password: '',
			passwordConfirmation: '',
			isSettingNewPassword: false,
			isCodeValid: false,
			isVerifyingCode: true,
		};
	},
	methods: {
		...mapActions({
		}),
		validateCode() {
			this.isVerifyingCode = true;
			const params = {
				email: this.email,
				code: this.code,
			};
			const callback = () => {
				this.isVerifyingCode = false;
				this.isCodeValid = true;
			};
			const errorCallback = () => {
				this.isVerifyingCode = false;
				this.isCodeValid = false;
			};
			userApi.validateResetPasswordCode(params, callback, errorCallback);
		},
		setPassword(email, password, code) {
			this.isSettingNewPassword = true;
			const params = {
				email,
				password,
				code,
			};
			const callback = () => {
				this.isSettingNewPassword = false;
				this.success = true;
				this.error = false;
			};
			const errorCallback = (e) => {
				this.isSettingNewPassword = false;
				const message = e.response.data.message;
				this.error = message;
			};
			userApi.setPassword(params, callback, errorCallback);
		},
	},
	computed: {
		...mapGetters({
		}),
		email() {
			return this.$route.query.email;
		},
		code() {
			return this.$route.query.code;
		},
		isNewPasswordValid() {
			return this.password.length >= 6;
		},
		isNewPasswordMatch() {
			return this.password === this.passwordConfirmation;
		},
		isCanChangePassword() {
			return this.isNewPasswordValid && this.isNewPasswordMatch;
		},
	},
	created() {
		this.validateCode();
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.navbar-brand {
	margin: 0 auto;
}

.login {
	padding-top: 2rem;
}

h3 {
	font-weight: 300;
	text-align: center;
}

.login-box {
	margin: 0 auto;
	margin-top: 2rem;
	padding: 4em;
	padding-bottom: 3em;
	max-width: 600px;
	border-radius: 2px;
	border: 1px solid #d7d7da;
	box-shadow: 0 1px 10px -4px #9c9c9c;
}

.login-error {
	margin-bottom: 2em;
	font-size: .95em;
}

.login-action {
	display: inline-block;
	margin-top: 2em;
	// color: #75cfd8 !important;
	font-weight: bold;
	cursor: pointer;
}

.btn-submit {
	margin-top: 2rem;
	font-weight: bold;
}

.link-expired-box {
	margin: 3em auto;
	max-width: 500px;
}
</style>
